// DAS-65 Phase 3.5: DesignReviewNotice
// v2 미구현(BE gap) 페이지에 표시하는 안내 카드.
// /design-review/ → public/design-review/index.html 정적 파일로 서빙.

import React from 'react';

const ExternalLinkIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-4 w-4 flex-shrink-0"
        aria-hidden="true"
    >
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
);

const InfoIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5 flex-shrink-0 text-brand-light"
        aria-hidden="true"
    >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
);

/**
 * DesignReviewNotice — v2 시안 미포팅 페이지에 표시되는 안내 카드.
 * Phase 3.5 이전에도 안전하게 렌더된다 (링크 404여도 UI 유지).
 */
const DesignReviewNotice = () => (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
        <div className="w-full max-w-md rounded-2xl border border-surface-border bg-surface-card p-6 shadow-card">
            <div className="mb-4 flex items-start gap-3">
                <InfoIcon />
                <div>
                    <h2 className="text-sm font-semibold text-content">
                        v2 시안 포팅 준비 중
                    </h2>
                    <p className="mt-1 text-xs leading-relaxed text-content-secondary">
                        v2 시안은 BE 지원 작업 후 실 앱에 포팅됩니다.{' '}
                        현재는{' '}
                        <span className="font-medium text-content">/design-review</span>
                        {' '}에서 시안을 확인할 수 있습니다.
                    </p>
                </div>
            </div>

            <div className="flex flex-col gap-2">
                <a
                    href="/design-review/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="v2 시안 리뷰어 열기 (새 탭)"
                    title="v2 디자인 리뷰어"
                    className="
                        flex items-center justify-center gap-2 rounded-lg
                        border border-brand bg-brand-subtle px-4 py-2.5
                        text-sm font-medium text-brand-light
                        hover:bg-brand hover:text-content-inverse
                        transition-colors duration-150
                        min-h-[44px]
                    "
                >
                    <ExternalLinkIcon />
                    <span>시안 리뷰어 열기</span>
                </a>
                <p className="text-center text-xs text-content-muted">
                    V1으로 전환하면 현행 페이지를 그대로 사용할 수 있습니다.
                </p>
            </div>
        </div>
    </div>
);

export default DesignReviewNotice;
